import "@aws-amplify/ui-react/styles.css";
import { Box, Center, Heading } from '@chakra-ui/react'
import React from "react";
import { Explore } from "../controls/Explore";
import BasePage from "../controls/BasePage";
import { LoadingBlock } from "../controls/LoadingBlock";
import PostDisplay from "../controls/PostDisplay";
import { SiteData } from "../clients/data-service";
import { BasePageProps } from "../controls/BasePageProps";

interface SitePostProps extends BasePageProps {
    postId: string
}

class SitePost extends BasePage<SitePostProps> {
    render() {
        if (this.state.data == null) {
            return <LoadingBlock />;
        }

        const sitePost = this.state.data.Posts.find(p => p.id === this.props.postId);
        if (sitePost == null) {
            return <></>;
        }

        return (<>
            <Center>
                <Box w="fill" ml={{ base: 8, md: 20 }} mr={{ base: 8, md: 20 }} mb={60} maxW="1000">
                    <PostDisplay post={sitePost} siteData={this.state.data} />
                </Box>
            </Center>
        </>)
    }
}

export default SitePost;